/**
 * B-307 — mechanizm „wyciszania" liczników operacyjnych USUNIĘTY.
 *
 * Do 25.08 widoki Awarii, Zdarzeń, Kontroli i Dziennika służby miały przycisk
 * „Oznacz jako przeczytane". Nie oznaczał niczego: w żadnym z tych modułów nie
 * ma stanu przeczytania, a liczba przy przycisku to liczba pozycji **otwartych**
 * (zgłoszone + zdiagnozowane + w naprawie; otwarte zdarzenia; kontrole po
 * terminie i zbliżające się; otwarte wpisy dziennika). Kliknięcie zapisywało
 * w `localStorage` „najwyższy widziany stan" i chowało plakietkę w menu, dopóki
 * licznik go nie przekroczy.
 *
 * ── Dlaczego to było gorsze niż nic ────────────────────────────────────────
 * Po wyciszeniu liczba przestawała cokolwiek znaczyć. Zgłoszone przez
 * właściciela na przykładzie Awarii: przy 17 otwartych, zamknięciu dwóch
 * i trzech nowych zgłoszeniach plakietka pokazywała **18 — w tym 15 starych**.
 * Do tego znacznik żył w przeglądarce jednej osoby: nikt inny go nie widział,
 * a sam nie miał jak zniknąć.
 *
 * Liczniki pokazują teraz stan faktyczny i schodzą wtedy, gdy pozycja zostanie
 * **zamknięta** — czyli wtedy, kiedy praca naprawdę została wykonana.
 *
 * Zostaje wyłącznie sprzątanie: wpisy zapisane przez poprzednią wersję kasujemy
 * raz, przy starcie. Bez tego leżałyby w przeglądarce bez końca — nieszkodliwe
 * dziś, ale gotowe znowu zaniżyć licznik, gdyby ktoś kiedyś przywrócił odczyt.
 */

/** Klucze zapisywane przez wersje sprzed 1.346.0. */
const STARE_KLUCZE = ['incidents', 'failures', 'inspections', 'dutyLog', 'forms'] as const;

export function wyczyscZnacznikiLicznikow(): void {
  for (const k of STARE_KLUCZE) {
    try { window.localStorage.removeItem(`zuris-badgeAck-${k}`); } catch { /* ignore */ }
  }
}
